import styles from "./FanaticalPopover.module.css"
import { Box, Popover, PopoverProps, Typography } from "@mui/material";
import { FC, useState } from "react";
import Button, { ButtonKind, ButtonSize } from "../Buttons/Button/Button";
import { useTranslations } from "next-intl";

export type FanaticalPopoverProps = {
  anchorEl: PopoverProps["anchorEl"];
  open: boolean;
  darkBackground: boolean;
  initialStep?: number;
  onStep?: () => void;
  onClose: () => void;
  anchorOrigin?: PopoverProps["anchorOrigin"];
  transformOrigin?: PopoverProps["transformOrigin"];
};

const FanaticalPopover: FC<FanaticalPopoverProps> = ({
  anchorEl,
  open,
  onClose,
  onStep,
  initialStep = 1,
  darkBackground = false,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'center' }
}) => {

    const [step, setStep] = useState(initialStep)
    const t = useTranslations("FanaticalPopover")

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={step === 1 ? { vertical: 'bottom', horizontal: 'right' } : anchorOrigin}
      transformOrigin={step === 1 ? { vertical: 'top', horizontal: 'right' } : transformOrigin}
      disableRestoreFocus
      className={`${styles.popover} ${darkBackground ? styles.darkBackground : ''}`}
      data-testid="FanaticalPopover"
    >
      {step === 1 && <Box p={2} className={styles.tooltipBox}>
        <h4 className={styles.title} data-testid="FanaticalPopover_step1title">{t('step1_title')}</h4>
        <Typography variant="body2" mb={1} data-testid="FanaticalPopover_step1text">
          {t('step1_text')}
        </Typography>

        <Button
          size={ButtonSize.SMALL}
          kind={ButtonKind.SUGGESTED}
          onClick={(e) => {
            if(onStep) onStep()
            setStep(2)
          }}
          data-testid="FanaticalPopover_nextStepButton"
        >
          {t('step1_button')}
        </Button>
        <div className={styles.dots} data-testid="FanaticalPopover_slideIndicators">
          <div className={`${styles.dot} ${styles.active}`}></div>
          <div className={styles.dot}></div>
        </div>
      </Box>}
        {step === 2 && <Box p={2} className={styles.tooltipBox}>
          <h4 className={styles.title} data-testid="FanaticalPopover_step2title">{t('step2_title')}</h4>
        <Typography variant="body2" mb={1} data-testid="FanaticalPopover_step2text">
          {t('step2_text')}
        </Typography>

        <Button
          size={ButtonSize.SMALL}
          kind={ButtonKind.SUGGESTED}
          onClick={(e) => {
            onClose();
          }}
          data-testid="FanaticalPopover_closeButton"
        >
          {t('step2_button')}
        </Button>
        {initialStep === 1 && <div className={styles.dots}>
          <div className={styles.dot}></div>
          <div className={`${styles.dot} ${styles.active}`}></div>
        </div>}
      </Box>}
    </Popover>
  );
};

export default FanaticalPopover;